import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
export function Guarantee() {
  return <section className="w-full bg-navy px-4 py-14" aria-labelledby="garantia" data-id="element-174" data-mp="20m4qnvskykwl">
      <div className="mx-auto w-full max-w-2xl text-center" data-id="element-175" data-mp="24m5gsdp1kkjh">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-white/10" data-id="element-176" data-mp="29dwydyq7zfxh">
          <ShieldCheckIcon className="h-10 w-10 text-white" aria-hidden="true" data-id="element-177" data-mp="2ed00baawl618" />
        </div>
        <h2 id="garantia" className="mt-5 font-display text-2xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-178" data-mp="2jc4bu7lavfuq">
          Garantía de satisfacción de 7 días
        </h2>
        <p className="mt-4 text-[15px] leading-relaxed text-white/80" data-id="element-179" data-mp="2scsszb5zpwbu">
          El riesgo es completamente nuestro. Revísala, utilízala y compárala con
          la forma en que hoy tomas decisiones. Si en los próximos 7 días sientes
          que no aporta más claridad, rapidez y seguridad a tu práctica clínica,
          solo escríbenos.
        </p>
        <p className="mt-4 text-lg font-extrabold text-white" data-id="element-180" data-mp="3smzox48cthz4">
          Te devolvemos el 100% de tu dinero.
        </p>
        <p className="mt-2 text-sm text-white/60" data-id="element-181" data-mp="3nsn68wepcaof">
          Sin formularios interminables. Sin explicaciones incómodas. Sin letra
          pequeña.
        </p>

        <div className="mt-8" data-id="element-182" data-mp="3dxv7hp9dvhs2">
          <CTAButton label="Quiero probarlo sin riesgo" data-id="element-183" data-mp="3dufs0lbss6q4" />
        </div>
      </div>
    </section>;
}